import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const TikTok = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        fill="inherit"
        d="M29.638 14.72v3.777a9.93 9.93 0 0 1-5.231-2.117v7.633l-.016-.024q.015.228.016.462a6.885 6.885 0 0 1-6.877 6.876 6.885 6.885 0 0 1-6.877-6.876c0-3.791 3.085-6.878 6.877-6.878q.557 0 1.092.086v3.723a3.26 3.26 0 0 0-4.349 3.07 3.26 3.26 0 0 0 3.257 3.255 3.26 3.26 0 0 0 3.251-3.458V9.415h3.774l.04.961c.026.63.25 1.234.641 1.728a7.2 7.2 0 0 0 2.085 1.797c.89.503 1.726.72 2.317.822z"
      />
    </svg>
  );
};
